import MDTypography from "components/MDTypography";
import { Button, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import RestoreIcon from "@mui/icons-material/Restore";
import DownloadIcon from "@mui/icons-material/Download";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
function RowAction({ row, onDelete, onRestore, onDownload, description, dynamicName }) {
  const isViewOnly = AuthenticationService.isViewOnlyUser();
  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">

      {onRestore && !isViewOnly && (
        <Tooltip title="Restore backup">
          <IconButton color="success" onClick={() => onRestore(row)}>
            <RestoreIcon />
          </IconButton>
        </Tooltip>
      )}

      {onDownload && (
        <Tooltip title="Download backup">
          <IconButton color="info" onClick={() => onDownload(row)}>
            <DownloadIcon />
          </IconButton>
        </Tooltip>
      )}

      {onDelete && !isViewOnly && (
        <Tooltip title={dynamicName ? dynamicName : "Delete backup"}>
          <IconButton color="error" onClick={() => onDelete(row)}>
            {description ? (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "crimson",
                  "&:hover": { backgroundColor: "darkred" },
                }}
              >
                {description}
              </Button>
            ) : (
              <DeleteIcon />
            )}
          </IconButton>
        </Tooltip>
      )}
    </MDTypography>
  );
}

export default RowAction;
